import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadPoliciesListBegin, loadPoliciesListFailed, loadPoliciesListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { normalizePolicyFilter } from '../../../dto/PoliciesDTO';

export default function* loadPoliciesList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    const normalizedFilter = normalizePolicyFilter(filter);
    if (Object.keys(normalizedFilter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(normalizedFilter, pool);
    }
    const url = `${BACKEND_URL}/policies`;
    yield put(loadPoliciesListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.policies) {
      yield put(loadPoliciesListSuccessful({
        data: data.policies,
        meta: data.meta,
      }));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadPoliciesListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadPoliciesListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
